import { mapMutations } from 'vuex';

const viewport = {
   data() {
      return {
         scrollTimeout: null,
         resizeTimeout: null,
      };
   },
   methods: {
      ...mapMutations("viewport", ["updateSize", "updateScroll", "setWebp"]),
      handleResize() {
         // If there's a timer, cancel it
         if (this.resizeTimeout) {
            window.cancelAnimationFrame(this.resizeTimeout);
         }

         const self = this;

         // Setup the new requestAnimationFrame()
         this.resizeTimeout = window.requestAnimationFrame(() => {
            // const width = window.innerWidth
            // const height = window.innerHeight

            // console.log({ width, height })
            // console.log('window resize', window.screen.orientation)
            self.updateSize();
         });
      },
      handleScroll() {
         // If there's a timer, cancel it
         if (this.scrollTimeout) {
            window.cancelAnimationFrame(this.scrollTimeout);
         }

         const self = this;

         // Setup the new requestAnimationFrame()
         this.scrollTimeout = window.requestAnimationFrame(() => {
            // const x = window.scrollX
            // const y = window.scrollY
            // console.log({ x, y })
            self.updateScroll();
         });
      },
      async supportsWebp() {
         return new Promise((resolve) => {
            var image = new Image();
            image.onerror = function() {
               return resolve(false);
            };
            image.onload = function() {
               return resolve(image.width === 1);
            };
            image.src =
               "data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=";
         }).catch(() => {
            return false;
         });
      },
   },
   // computed: {
   ...mapMutations("viewport", ["breakpoint"]),
   // 	...mapState('breakpoint', ['breakpoint', 'breakpoints'])
   // },
   // async created() {
   //    const webp = await this.supportsWebp();
   //    this.setWebp(webp);
   //    console.log(" ~~~~~~~~~~ created viewport mixin", this.$store.state);
   // },
   mounted() {
      window.addEventListener("resize", this.handleResize, false);
      window.addEventListener("scroll", this.handleScroll, false);

      // Set viewport size and scroll state

      this.updateScroll();
      this.updateSize();
   },
   destroyed() {
      if (this.scrollTimeout) {
         window.cancelAnimationFrame(this.scrollTimeout);
      }

      if (this.resizeTimeout) {
         window.cancelAnimationFrame(this.resizeTimeout);
      }

      window.removeEventListener("resize", this.handleResize);
      window.removeEventListener("scroll", this.handleScroll);
   },
};

export default viewport;
